import axios from "axios";
import { getIP } from "../../../ui";

const logRecemedProcedureExam = async (
    action,
    response,
    professionalName,
    professionalRut,
    patientName,
    patientLastName,
    patientRut,
    detail,
    IP
) => {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    let date = new Date();

    db.collection("logRecemed").add({
        log_date: date,
        action,
        response: { ...response.data },
        professionalRut,
        professionalName,
        patientRut,
        patientName: `${patientName.trim()} ${patientLastName.trim()}`,
        detail,
        ip: IP.IPv4,
        country: IP.country_name,
    });
};

const logRecemedErrorProcedureExam = async (
    action,
    error,
    professionalName,
    professionalRut,
    patientName,
    patientLastName,
    patientRut,
    detail,
    IP
) => {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    let date = new Date();

    db.collection("logRecemed").add({
        log_date: date,
        action,
        error,
        professionalRut,
        professionalName,
        patientRut,
        patientName: `${patientName.trim()} ${patientLastName.trim()}`,
        detail,
        ip: IP.IPv4,
        country: IP.country_name,
    });
};

//Método para guardar el Log Error cuando se crea Receta
const enviarLogErrorCreatePrescription = async (
    action,
    error,
    profRut,
    profName,
    patientRut,
    patientName,
    patientLastName,
    IP
) => {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    //Se crea la fecha actual en la que se crea el Log
    let date = new Date();

    //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
    db.collection("logRecemed").add({
        log_date: date,
        action: action,
        error: error,
        professional: profRut,
        professionalName: profName,
        patient: patientRut,
        patientName: `${patientName} ${patientLastName}`,
        ip: IP.IPv4,
        country: IP.country_name,
    });
};

const logRecemed = async (
    action,
    control,
    response,
    professionalName,
    professionalRut,
    patientName,
    patientLastName,
    patientRut,
    medicine
) => {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    let date = new Date();

    db.collection("logRecemed").add({
        log_date: date,
        action,
        control,
        response: { ...response.data },
        professionalRut,
        professionalName,
        patientRut,
        patientName: `${patientName.trim()} ${patientLastName.trim()}`,
        medicine,
    });
};


export async function obtener_ordenes(
    idMedico,
    idPaciente,
    detalle,
    observaciones,
    profRut,
    profName,
    patientRut,
    patientName,
    patientLastName
) {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;

    // Usar map para transformar cada objeto en una cadena
    const arrayExamenes = detalle.map(objeto => `${objeto.examen}`);

    // Usar join para unir las cadenas con saltos de línea
    const ordenes = arrayExamenes.join('\n');

    const data = {
        idMedico,
        idPaciente,
        detalle: ordenes,
        observaciones
    };

    return axios.post(`${urlServer}/recemed/addexamen`, data)
        .then((response) => {
            if (response.data.error) {
                getIP().then((responseIP) => {
                    logRecemedErrorProcedureExam(
                        "[Recemed] Create Order",
                        { ...response.data.error.error },
                        profName,
                        profRut,
                        patientName,
                        patientLastName,
                        patientRut,
                        `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
                        responseIP.data
                    );
                });
                return Promise.reject(response.data.error); // Rechazar la promesa en caso de error
            } else {
                getIP().then((responseIP) => {
                    logRecemedProcedureExam(
                        "[Create Order]",
                        response,
                        profName,
                        profRut,
                        patientName,
                        patientLastName,
                        patientRut,
                        `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
                        responseIP.data
                    );
                });
                return response.data;
            }
        })
        .catch((error) => {
            getIP().then((response) => {
                logRecemedErrorProcedureExam(
                    "[Recemed] Create Order",
                    error.toString(),
                    profName,
                    profRut,
                    patientName,
                    patientLastName,
                    patientRut,
                    `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
                    response.data
                );
            });
            return Promise.reject(error); // Rechazar la promesa en caso de error
        });
}

export async function obtener_procedimientos(
    idMedico,
    idPaciente,
    detalle,
    profRut,
    profName,
    patientRut,
    patientName,
    patientLastName
) {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;

    const data = {
        idMedico,
        idPaciente,
        detalle,
    };

    return axios.post(`${urlServer}/recemed/addprocedimiento`, data)
        .then((response) => {
            if (response.data.error) {
                getIP().then((responseIP) => {
                    logRecemedErrorProcedureExam(
                        "[Recemed] Create Procedure",
                        { ...response.data.error.error },
                        profName,
                        profRut,
                        patientName,
                        patientLastName,
                        patientRut,
                        detalle,
                        responseIP.data
                    );
                });
                return Promise.reject(response.data.error); // Rechazar la promesa en caso de error
            } else {
                getIP().then((responseIP) => {
                    logRecemedProcedureExam(
                        "[Create Procedure]",
                        response,
                        profName,
                        profRut,
                        patientName,
                        patientLastName,
                        patientRut,
                        detalle,
                        responseIP.data
                    );
                });
                return response.data;
            }
        })
        .catch((error) => {
            getIP().then((response) => {
                logRecemedErrorProcedureExam(
                    "[Recemed] Create Procedure",
                    error.toString(),
                    profName,
                    profRut,
                    patientName,
                    patientLastName,
                    patientRut,
                    detalle,
                    response.data
                );
            });
            return Promise.reject(error); // Rechazar la promesa en caso de error
        });
}

export async function obtener_medicamentos_controlados(
    patientMedicalPlan,
    idDoctor,
    idPacient,
    medicine,
    ges,
    profRut,
    profName,
    patientRut,
    patientName,
    patientLastName
) {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;

    const indication = `${medicine.resume_indication.morning === ""
        ? ""
        : `\n\t ${medicine.resume_indication.morning}`
        }${medicine.resume_indication.afternoon === ""
            ? ""
            : `\n\t ${medicine.resume_indication.afternoon}`
        }${medicine.resume_indication.night === ""
            ? ""
            : ` \n\t ${medicine.resume_indication.night}`
        }${medicine.resume_indication.days === ""
            ? ""
            : `\n\t ${medicine.resume_indication.days}`
        }${medicine.resume_indication.number_boxes === ""
            ? ""
            : `\n\t ${medicine.resume_indication.box}`
        }${medicine.indication === ""
            ? ""
            : `\n\nIndicaciones Adicionales\n\t -${medicine.indication}`
        }`;

    const data = {
        medico: idDoctor,
        paciente: idPacient,
        atributos: {
            detalle: medicine.name.data.name,
            observaciones: indication,
            retenida: true,
            registra_ges: null,
            patologia: null,
            isapre: patientMedicalPlan,
            duracion: Math.round(medicine.days / 30),
        },
    };

    return axios.post(`${urlServer}/recemed/addreceta`, data)
        .then((response) => {
            if (response.data.error) {
                getIP().then((responseIP) => {
                    enviarLogErrorCreatePrescription(
                        "[Recemed] Create Prescription Withheld",
                        { ...response.data.error.error },
                        profRut,
                        profName,
                        patientRut,
                        patientName,
                        patientLastName,
                        responseIP.data
                    );
                });
                return Promise.reject(response.data.error); // Rechazar la promesa en caso de error
            } else {
                logRecemed(
                    "[Create Receta]",
                    "Retenida",
                    response,
                    profName,
                    profRut,
                    patientName,
                    patientLastName,
                    patientRut,
                    medicine
                );
                return response.data;
            }
        })
        .catch((error) => {
            getIP().then((responseIP) => {
                enviarLogErrorCreatePrescription(
                    "[Recemed] Create Prescription Withheld",
                    error.toString(),
                    profRut,
                    profName,
                    patientRut,
                    patientName,
                    patientLastName,
                    responseIP.data
                );
            });
            return Promise.reject(error); // Rechazar la promesa en caso de error
        });
}

export async function obtener_medicamentos_nocontrolados(
    patientMedicalPlan,
    idDoctor,
    idPacient,
    medicamentos,
    ges,
    profRut,
    profName,
    patientRut,
    patientName,
    patientLastName
) {
    const { getReduxStore } = await import('../../../../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;

    let observationsNoWithheldMedicines = "";

    medicamentos.forEach((medicine) => {
        observationsNoWithheldMedicines += `${medicine.name.data.name}
        ${medicine.resume_indication.morning === ""
                ? ""
                : `\n\t ${medicine.resume_indication.morning}`
            }${medicine.resume_indication.afternoon === ""
                ? ""
                : `\n\t ${medicine.resume_indication.afternoon}`
            }${medicine.resume_indication.night === ""
                ? ""
                : ` \n\t ${medicine.resume_indication.night}`
            }${medicine.resume_indication.days === ""
                ? ""
                : `\n\t ${medicine.resume_indication.days}`
            }${medicine.resume_indication.number_boxes === ""
                ? ""
                : `\n\t ${medicine.resume_indication.box}`
            }${medicine.indication === ""
                ? ""
                : `\n\n\t Indicaciones Adicionales \n\t\t -${medicine.indication}
            `
            }
        \n`;
    });

    const data = {
        medico: idDoctor,
        paciente: idPacient,
        atributos: {
            detalle: observationsNoWithheldMedicines,
            observaciones: observationsNoWithheldMedicines,
            registra_ges: null,
            patologia: null,
            isapre: patientMedicalPlan,
            duracion: 0,
        },
    };

    return axios.post(`${urlServer}/recemed/addrecetadigital`, data)
        .then((response) => {
            if (response.data.error) {
                getIP().then((responseIP) => {
                    enviarLogErrorCreatePrescription(
                        "[Recemed] Create Prescription NoWithheld",
                        { ...response.data.error.error },
                        profRut,
                        profName,
                        patientRut,
                        patientName,
                        patientLastName,
                        responseIP.data
                    );
                });
                return Promise.reject(response.data.error); // Rechazar la promesa en caso de error
            } else {
                logRecemed(
                    "[Create Receta]",
                    "No Retenida",
                    response,
                    profName,
                    profRut,
                    patientName,
                    patientLastName,
                    patientRut,
                    observationsNoWithheldMedicines
                );
                return response.data;
            }
        })
        .catch((error) => {
            getIP().then((response) => {
                enviarLogErrorCreatePrescription(
                    "[Recemed] Create Prescription NoWithheld",
                    error.toString(),
                    profRut,
                    profName,
                    patientRut,
                    patientName,
                    patientLastName,
                    response.data
                );
            });
            return Promise.reject(error); // Rechazar la promesa en caso de error
        });
}

